const orderRoutes = {
	pedidos: {
		path: '/pedidos',
		name: 'Pedidos',
		component: () => import('@/views/Pedidos.vue'),
		meta: { title: 'Pedidos' }
	},
	pedido: {
		path: '/pedido/:pedido_id',
		name: 'Pedido',
		component: () => import('@/views/Pedido.vue'),
		meta: { title: 'Pedido' }
	}
}

export default orderRoutes
